import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.ts";
import {ContactCache} from "./ContactCache.ts";
import {ControllerBook} from "../page/ControllerBook.ts";
import CONTACTS_LIST_TEMPLATE from "./contacts_list.mustache";
import CONTACT_DETAILS_TEMPLATE from "./contact_details.mustache";
import TPL_RIGHT_EMPTY from "./contact_empty.mustache";
import * as libLocation from "../lib/location.ts";
import * as segment from "../tracking-segment.ts";

INR.onPage(INR.URL.CONTACTS,function(){

  async function datachanged(ctc?: any): Promise<void> {
    CONTROLLER.onRefresh(await ContactCache.refresh())

    if(ctc instanceof ApiServer.types.IContact){
      CONTROLLER.select(ctc.metaId)
    }

  }
  var CONTROLLER = new ControllerBook(document.querySelector('.pane-left'),CONTACTS_LIST_TEMPLATE,document.querySelector(".pane-main"),CONTACT_DETAILS_TEMPLATE,TPL_RIGHT_EMPTY,ContactCache);
  INR.subscribe("contactCreated",datachanged);
  INR.subscribe("contactUpdated",datachanged);
  INR.subscribe("contactDeleted",datachanged);

  //a contact opened by the user is in the url, the automatic selection of the first one on desktop is not
  let viewedContactId: string;
  function trackContactViewed(){
    const contactId = libLocation.getURLParam('metaId');
    if(contactId && contactId !== viewedContactId){
      segment.track("Contact Viewed");
    }
    viewedContactId = contactId;
  }
  trackContactViewed();
  INR.subscribe("handleParam",trackContactViewed);


});
